import { AppLayout } from "../../components/layout/Header";
import { MessagesDesk } from "../../components/messaging";
import AdminBrokerNotes from "./AdminBrokerNotes";

export default function AdminMessages() {
  return (
    <AppLayout variant="admin">
      <MessagesDesk deskRole="admin">
        <AdminBrokerNotes />
      </MessagesDesk>
    </AppLayout>
  );
}
